/**
 * TIPS：单纯为了开发过程方便调整DEMO示例代码
 */
import { Component } from '@angular/core';

@Component({
  selector: 'mwc-demo-COMPONENTNAME-basic',
  template: ``
})
export class DEMOComponent {}
